import { useEffect, useState } from 'react';

export const useLocalStorageSubscribe = () => {
  const [, setLocalStorageKey] = useState(0);

  useEffect(() => {
    const handleStorageChange = () => {
      setLocalStorageKey((prevKey) => prevKey + 1);
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  const handleChange = () => window.dispatchEvent(new Event('storage')); // Вызывать для обновления ls без перезагрузки страницы

  return { handleChange };
};
